module.exports = __webpack_public_path__ + "img/date_range_black.eb8712b3.svg";